export default __webpack_public_path__ + "static/media/green_light.f19c329d.png";